// extracted by mini-css-extract-plugin
module.exports = {"editableRow":"WishesTable_editableRow__2YvTO"};